import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Navigation() {
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const NavLinks = [
    { title: "Home", route: "home" },
    { title: "Services", route: "services" },
    { title: "FAQs", route: "faqs" },
    { title: "Contact Us", route: "contact" },
  ];

  const location = useLocation();
  const currentPath = location.pathname.slice(1) || "home";

  return (
    <>
      <header className={`header ${isFixed ? "fixed-top" : ""}`}>
        <div className="main-header">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light p-0">
              <Link className="navbar-brand" to="/">
                <figure className="navbar-logo mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/final-logo-sd.png"
                    alt="Logo"
                  />
                </figure>
              </Link>
              <button
                className="navbar-toggler collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
                <span className="navbar-toggler-icon"></span>
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav m-auto">
                  {NavLinks.map((item, index) => (
                    <li
                      key={index}
                      className={`nav-item ${
                        currentPath === item.route ? "active" : ""
                      }`}
                    >
                      <Link className="nav-link scroll" to={`/${item.route}`}>
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
                <Link to="/book-a-demo" className="form-btn hover-effect d-block">Get A Quote</Link>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navigation;
